const firebaseConfig = {
  apiKey: "AIzaSyC-gGZI3cvY4d32_pABqEPP8WWpE05ECCU",
  authDomain: "softsite-tts.firebaseapp.com",
  databaseURL: "https://softsite-tts.firebaseio.com",
  projectId: "softsite-tts",
  storageBucket: "softsite-tts.appspot.com",
  messagingSenderId: "207247189092",
  appId: "1:207247189092:web:2dc738d14084afa4fb6b71"
};
export default firebaseConfig